function normalizeStatus(value) {
  return Number(value || 0)
}

function isExpertReviewFinished(record) {
  if (!record) return false
  const status = normalizeStatus(record.status)
  // status 0=不推荐(已完成), 1=推荐(已完成), 2=待审(未完成), 5/6=其他终态
  return status === 0 || status === 1 || status === 5 || status === 6
}

function isInitialReviewComplete(row) {
  return isExpertReviewFinished(row && row.mainexpert) && isExpertReviewFinished(row && row.reexpert)
}

function isLeaderBlocked(row) {
  const status = normalizeStatus(row && row.status)
  return status === 5 ||
    status === 6 ||
    status === 7 ||
    status === 8 ||
    status === 9 ||
    (row && row.is_returned == 1) ||
    (row && row.return_type === 'enterprise') ||
    (row && row.return_type === 'initial')
}

function canLeaderReview(row) {
  return !!row && normalizeStatus(row.status) === 3 && isInitialReviewComplete(row) && !isLeaderBlocked(row)
}

function getExpertId(record) {
  if (!record) return null
  return record.expert_id || record.checker_id || (record.expert && record.expert.id) || null
}

function normalizeRecommendDecision(value) {
  if (value === true || value === 1 || value === '1' || value === 'true' || value === '是' || value === 'yes') {
    return true
  }
  if (value === false || value === 0 || value === '0' || value === 'false' || value === '否' || value === 'no') {
    return false
  }
  return null
}

function buildReturnInitialPayload(selectedRoles, reason, row) {
  const roles = selectedRoles || []
  const ids = []
  if (roles.indexOf('main') !== -1) {
    const id = getExpertId(row && row.mainexpert)
    if (id) ids.push(id)
  }
  if (roles.indexOf('second') !== -1) {
    const id = getExpertId(row && row.reexpert)
    if (id) ids.push(id)
  }
  return {
    action: 'reject_to_primary',
    reject_expert_ids: ids,
    reject_reason: String(reason || '').trim(),
  }
}

function buildReviewDecisionFromOpinion(opinion) {
  const data = opinion || {}
  const recommend = normalizeRecommendDecision(data.recommend_provincial && data.recommend_provincial.pass)
  if (recommend !== true && recommend !== false) {
    throw new Error('请选择是否推荐')
  }
  if (recommend === false) {
    const reason = String(data.rejection_reason || '').trim()
    if (!reason) {
      throw new Error('请填写不推荐理由')
    }
    return {
      status: 2,
      reject_reason: reason,
    }
  }
  return {
    status: 1,
    reject_reason: '',
  }
}

module.exports = {
  buildReturnInitialPayload,
  buildReviewDecisionFromOpinion,
  canLeaderReview,
  isInitialReviewComplete,
  normalizeRecommendDecision,
}
